module.exports = __webpack_public_path__ + "static/media/sylber.fb7c61cb.png";